export default __webpack_public_path__ + "media/images/ui-icons_ffffff_256x240-3e953c79334b220e0022a07d90a2e32b.png";